import { Component, ElementRef, Input } from '@angular/core';
import { CheckoutStepComponentDef } from '@df/checkout/checkout-step.component.def';
import { App } from '@df/core/app';
import { Logger } from '@df/core/service/logger';
import { getElementHeight } from '@df/dom/fn/get-element-height';
import { IScrollToOptions } from '@df/dom/scroll/scroll-to.service';
import { ScrollToErrorService } from '@df/ui/form/scroll-to-error.service';
import { HEADER_ID } from '../../layout/page/header/page-header.component';
import { CheckoutFormComponent } from './../form/checkout-form.component';
declare module '@df/checkout/checkout.interfaces' {
    namespace Checkout {
        interface IStep {
            stepGroup?: string;
        }
    }
}
@Component({
    selector: 'checkout-step',
    templateUrl: './checkout-step.html',
    providers: [{ provide: CheckoutStepComponentDef, useExisting: CheckoutStepComponent }],
    standalone: true
})
export class CheckoutStepComponent extends CheckoutStepComponentDef {
    @Input()
    hideInactive = false;
    @Input()
    stepGroup?: string;
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        ngEl: ElementRef,
        app: App,
        protected override logger: Logger,
        protected override scrollToErrorService: ScrollToErrorService,
    ) {
        super(checkoutFormComponent, ngEl, app, logger, scrollToErrorService);
    }

    protected getToErrorScrollOptions(): IScrollToOptions {
        const headerHeight = getElementHeight(`#${HEADER_ID}`);
        return { offset: headerHeight || 0 };
    }
    get isStepVisible(): boolean {
        if (this.hideInactive) {
            return this.isCurrent;
        }
        return this.checkoutFormComponent.getStepIndex(this.name) <= this.checkoutFormComponent.currentStepIndex;
    }
}
